import React, { useState, useContext } from "react";
import { ValidateFiveDigitCode } from "../../../utils/Helpers/PostalCodeValidator";

import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

// import getUserPref from "../../../context/UserPrefs/getUserPref";

import { FormattedMessage } from "react-intl";

const InputZipcodeForChargingMap = ({
  filteredChargingStations,
  setFilteredChargingStations,
}) => {
  const userPrefs = useContext(UserPrefsContext);
  const defaultZipcode = userPrefs.get('zipcode') ? userPrefs.get('zipcode') : '94123' 
  const [workingZipcode, setWorkingZipcode] = useState(defaultZipcode)

  const isInvalid = userPrefs.zipcodeIsNotFound && !userPrefs.zipcodeIsUpdating;

  const id = "input-zipcode-for-charging-map";

  const handleUpdateButtonPress = (e, input) => {
    if (input && e.key !== "Enter") return;

    if (ValidateFiveDigitCode(workingZipcode) && !userPrefs.zipcodeIsUpdating) {
      async function asyncCall() {
        await userPrefs.set({ workingZipcode: workingZipcode });
        if (!userPrefs.zipcodeIsUpdating) {
          userPrefs.syncWorkingZipcode();
        }
      }
      asyncCall();
    }
  };

  return (
    <>
      <div className="input-zipcode-container">
        <div className="form-group">
          <label htmlFor={id}>
            <FormattedMessage
              id="zipcode"
              defaultMessage="Zipcode"
              description="Zipcode"
            />
          </label>

          <div className="input-group mb-2 mr-sm-2">
            <input
              id={id}
              className={isInvalid ? "form-control is-invalid" : "form-control"}
              value={workingZipcode}
              onChange={(e) => setWorkingZipcode(e.target.value)}
              onKeyDown={(e) => handleUpdateButtonPress(e, "input")}
            />
          </div>

          {(isInvalid || !ValidateFiveDigitCode(workingZipcode)) && (
            <div className="text-danger small">
              Error: {workingZipcode} is not a valid zipcode
            </div>
          )}
        </div>

        <div className="form-group select-chargingstations">
          <label htmlFor="powerstation-type-select">
            <FormattedMessage
              id="type"
              defaultMessage="TYPE"
              description="TYPE"
            />
          </label>

          <div className="input-group mb-2 mr-sm-2">
            <select
              id="powerstation-type-select"
              className="form-control"
              value={filteredChargingStations}
              onChange={(e) => {
                setFilteredChargingStations(e.target.value);
              }}
            >
              <option value="All">All</option>
              <option value="High power">High power</option>
              <option value="Public">Public</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>

        <div className="form-group button-zipcode">
          <button
            type="button"
            className="btn-ae-custom-two btn-default mb-2 btn-block"
            onClick={() => handleUpdateButtonPress()}
            disabled={userPrefs.zipcodeIsUpdating}
            id="update-zipcode-button"
          >
            Search charging stations
          </button>
        </div>
      </div>
    </>
  );
};

export default InputZipcodeForChargingMap;
